import React, { useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

/**
 * this hook will help to prevent navigate routes.
 */

const usePrompt = (when, message = 'Leaving this page will discard unsaved changes.') => {
  const { navigator } = React.useContext(NavigationContext);

  useEffect(() => {
    if (!when) return;

    const push = navigator.push;

    navigator.push = (...args) => {
      if (window.confirm(message)) {
        navigator.push = push;
        navigator.push(...args);
      }
    };

    return () => {
      navigator.push = push;
    };
  }, [when, message, navigator]);
};

export default usePrompt;
